export default {
	"0d2e1b90358febcd8bd7ee6c1f9458b1": "Please select the order",
	"c7353da925eb14686e47cdb32f4cf09e": "A maximum of 10 orders can be selected",
	"e8be63df7edff444a7ea3e4847ca3ecf": "Your default address has been modified. Please confirm whether the following orders use the new default address?",
	"1403ab59566fad05e3ad123cbbdb97ac": "Cancel",
	"c5a7b0ed0583e58f1f388a4c6815bfeb": "Confirm the modification"
}
